import BaseProxy from './Proxy';

export default class TestProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/test', parameters);
  }

  anonymous() {
    return this.submit('get', `${this.endpoint}/anonymous`);
  }
}
